import { analytics, getAnalyticsInstance } from "../firebase";
// Don't import logEvent directly, will use the one from the analytics object

const analyticsService = {
  // User-related events
  async trackSignUp(method) {
    try {
      await analytics.logEvent("sign_up", {
        method: method,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  async trackLogin(method) {
    try {
      await analytics.logEvent("login", {
        method: method,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  // Project-related events
  async trackProjectCreation(projectId, projectType) {
    try {
      await analytics.logEvent("project_created", {
        project_id: projectId,
        project_type: projectType,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  async trackProjectUpdate(projectId, updateType) {
    try {
      await analytics.logEvent("project_updated", {
        project_id: projectId,
        update_type: updateType,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  // Hazard-related events
  async trackHazardCreation(hazardId, projectId, method) {
    try {
      await analytics.logEvent("hazard_created", {
        hazard_id: hazardId,
        project_id: projectId,
        creation_method: method, // 'manual' or 'auto_generated'
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  async trackHazardUpdate(hazardId, updateType) {
    try {
      await analytics.logEvent("hazard_updated", {
        hazard_id: hazardId,
        update_type: updateType, // e.g., 'details', 'mitigations', etc.
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  async trackRiskLevelChange(hazardId, oldRisk, newRisk) {
    try {
      await analytics.logEvent("risk_level_changed", {
        hazard_id: hazardId,
        old_risk_level: oldRisk,
        new_risk_level: newRisk,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  // AI-related events
  async trackAiGeneration(contentType, inputLength) {
    try {
      await analytics.logEvent("ai_generation", {
        content_type: contentType, // e.g., 'hazard', 'mitigation', 'project_context'
        input_length: inputLength,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  // General tracking methods
  async trackScreenView(screenName) {
    try {
      await analytics.logEvent("screen_view", {
        screen_name: screenName,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  async trackFeatureUsage(featureName, details) {
    try {
      await analytics.logEvent("feature_used", {
        feature_name: featureName,
        ...details, // Spread details directly instead of nesting them
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },

  // Error tracking
  async trackError(errorType, errorMessage, location) {
    try {
      await analytics.logEvent("app_error", {
        error_type: errorType,
        error_message: errorMessage,
        error_location: location,
      });
    } catch (error) {
      console.warn("Analytics error:", error);
    }
  },
};

export default analyticsService;